import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9808EEC5-35FB-45B1-AFCB-065E9CF469E4
 * name subtitles
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/subtitles.svg
 * tags
 */
export const SubtitlesIcon = createSvgIcon(<><path d="M20,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6A2,2 0 0,0 20,4M4,12H8V14H4V12M14,18H4V16H14V18M20,18H16V16H20V18M20,14H10V12H20V14Z" /></>, 'SubtitlesIcon');
export default SubtitlesIcon